/**
 * Google Analytics 4 (gtag.js) — integración en Terrio
 *
 * CONTEXTO
 * --------
 * Medición directa vía gtag.js (ID: G-7L9QP49M2T). El snippet oficial está en
 * public/index.html; este módulo maneja page views de la SPA y eventos custom.
 *
 * ARCHIVOS INVOLUCRADOS
 * ---------------------
 * - public/index.html                  → Snippet gtag.js en <head>
 * - .env                               → REACT_APP_GA_MEASUREMENT_ID (comentado en local)
 * - .github/workflows/main.yml         → Inyecta el ID solo en build de producción
 * - src/analytics/analytics.js         → Helpers para eventos y page views (este archivo)
 * - src/analytics/AnalyticsPageView.js → Page views virtuales en cada cambio de ruta
 * - src/App.js                         → Monta <AnalyticsPageView /> dentro del HashRouter
 *
 * QUÉ SE MIDE HOY
 * --------------
 * Solo visitas / navegación: gtag('config', id, { page_path }) en cada cambio de ruta
 * (necesario porque usamos HashRouter y GA4 no detecta SPA sola).
 *
 * QUÉ SE PODRÍA AGREGAR MÁS ADELANTE
 * ----------------------------------
 * Usar pushAnalyticsEvent() desde cualquier componente. Ejemplos:
 *
 *   pushAnalyticsEvent('login', { method: 'cognito' });
 *   pushAnalyticsEvent('tour_completed', { tour_name: 'product_tour' });
 *   pushAnalyticsEvent('share', { content_type: 'lot' });
 *
 * No enviar datos sensibles (emails, tokens, IDs de usuario, coordenadas) sin acuerdo.
 */

const GA_MEASUREMENT_ID = process.env.REACT_APP_GA_MEASUREMENT_ID;

function isGaEnabled() {
  return Boolean(GA_MEASUREMENT_ID && typeof window.gtag === "function");
}

/**
 * Envía un evento a GA4 vía gtag.
 */
export function pushAnalyticsEvent(event, params = {}) {
  if (!isGaEnabled()) return;

  window.gtag("event", event, params);
}

/**
 * Page view virtual para SPA con HashRouter.
 */
export function pushPageView(path) {
  if (!isGaEnabled()) return;

  // `page_location` explícito (= la URL real, que en HashRouter es origen + ruta + `#` + path): así el
  // path que se redacta en AnalyticsPageView (token del link del informe) tampoco viaja en la URL.
  const { origin, pathname, search } = window.location;
  window.gtag("config", GA_MEASUREMENT_ID, {
    page_path: path,
    page_location: `${origin}${pathname}${search}#${path}`,
  });
}

export function isAnalyticsActive() {
  return Boolean(GA_MEASUREMENT_ID);
}
